<template>
    <div>
        <group-card title="Upload Documents" icon="file_upload" :loading="loading_document_requests">
        <!--            <loading-icon-text-button-->
        <!--                @click="uploadAllFiles()"-->
        <!--                icon="file_upload"   -->
        <!--            >-->
        <!--                Upload All-->
        <!--            </loading-icon-text-button>-->
            <div class="md-layout-table md-xsmall-break">

                <div class="md-layout md-layout-table-header">
                    <div class="md-layout-item md-size-45">
                        <code>Document</code>
                    </div>
                    <div class="md-layout-item md-size-40">
                        <code>Selected File</code>
                    </div>
                    <div class="md-layout-item md-size-15">
                        <code>Action</code>
                    </div>
                </div>

                <div class="md-layout" v-for="document_request in document_requests" :key="document_request.id">
                    <div class="md-layout-item md-size-45 md-xsmall-size-100">
                        <span :title="document_request.name">{{ document_request.name }}</span>
                    </div>
                    <template v-if="document_request.name === 'Privacy Consent Online'">
                        <div class="md-layout-item md-size-40 md-xsmall-size-100">
                            <div>
                                <p class="md-caption" v-if="!document_request.recieved">Do you accept AusLoans Privacy Consent and Credit Guide ?</p>
                                <p class="md-caption" v-if="document_request.recieved">You have accepted AusLoans Privacy Consent and Credit Guide.</p>
                                <p><a :href="'https://www.ausloans.com.au/privacy-consent'" target="_blank">Privacy Consent and Credit Guide</a></p>
                            </div>
                        </div>
                        <div class="md-layout-item md-size-15 md-xsmall-size-100">
                            <div>
                                <loading-icon-text-button icon="check" :disabled="document_request.recieved" :loading="accepting_consent_loader" @click="onAcceptingConset(document_request)">
                                    <span v-if="!document_request.recieved">Accept</span>
                                    <span v-if="document_request.recieved">Accepted</span>
                                </loading-icon-text-button>
                            </div>
                        </div>
                    </template>
                    <template v-if="document_request.name !== 'Privacy Consent Online'">
                        <div class="md-layout-item md-size-40 md-xsmall-size-100">
                            <div v-if="document_request.url ||
                                        (document_request.url_name == 'Upload 3 months bank statements' || document_request.url_name == 'Upload 6 months bank statements')">
                                <p class="md-caption">Use the following link for submission: </p>
                                <p><a :href="document_request.url" target="_blank" @click="openBSLink(document_request)">{{ document_request.url_name || document_request.url }}</a></p>
                            </div>

                            <div v-else>
                                <span v-if="document_request.recieved">
                                    <p class="md-caption">Uploaded file: </p>
                                    <p>{{ document_request.filename }}</p>
                                </span>
                                <md-field v-else>
                                    <label>Select file</label>
                                    <md-file @change="setFiles(document_request , $event)" :accept="document_request.accepted_file_types" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout-item md-size-15 md-xsmall-size-100">
                            <!-- <div v-if="document_request.download_url">
                            <loading-icon-text-button
                                class="md-danger"
                                icon="delete"
                                @click="onDeleteFile(document_request)"
                                :loading="delete_document_id == document_request.id"
                                tooltip="Delete"
                                :disable="document_request.file"
                            >
                                Delete
                            </loading-icon-text-button>
                            </div> -->

                            <div v-if="!document_request.recieved">
                                <loading-icon-text-button
                                    v-if="document_request.url"
                                    @click="openBSLink(document_request, true)"
                                    icon="file_upload"
                                >
                                    Upload
                                </loading-icon-text-button>
                                <loading-icon-text-button
                                    v-else
                                    @click="onUploadFile(document_request)"
                                    :loading="uploading_document_id == document_request.id"
                                    :disabled="!document_request.file"
                                    icon="file_upload"
                                >
                                    Upload
                                </loading-icon-text-button>
                            </div>
                        </div>
                    </template>
                </div>
            </div>

            <md-dialog-alert
            :md-active.sync="error_dialog.show"
            :md-title="error_dialog.title"
            :md-content="error_dialog.content"
            />

        </group-card>
    </div>
</template>

<script>
import { GroupCard } from "@/components";
import { ValidatedTextInput } from "@/components";
import LoadingIconButton from '@/components/LoadingIconButton';
import LoadingIconTextButton from '@/components/LoadingIconTextButton';

export default {
    components: {
        GroupCard,
        ValidatedTextInput,
        LoadingIconButton,
        LoadingIconTextButton,
    },
    data() {
        return {
            document_requests: [],
            loading_document_requests: false,
            uploading_document_id: null,
            delete_document_id: null,
            all_selected_documents:[],
            error_dialog: {
                show: false,
                title: "",
                content: "",
            },
            accepting_consent_loader: false
        }
    },
    methods: {
        showDialogPopup(title, message) {
        this.error_dialog.title = title;
        this.error_dialog.content = message;
        this.error_dialog.show = true;
        },
        async uploadFile(document_request){
            try {

                let form_data = new FormData();
                form_data.append('file', document_request.file);

                if (document_request.file.size === 0) {
                  this.showDialogPopup("Please upload a file larger than 0 bytes", "Empty files are not allowed");
                  this.loading_document_requests = false;
                  return;
                }

                await axios.post(
                    `/api/v1/client/docs/${document_request.id}`,
                    form_data,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                );

            } catch (error) {
                console.error('document upload request failed');
                console.error(error);
            }
        },
        async onUploadFile(document_request){
            this.uploading_document_id = document_request.id;
            await this.uploadFile(document_request);
            await this.loadDocumentRequests();
            this.uploading_document_id = null;
        },

        async loadDocumentRequests(){
            this.loading_document_requests = true;
            try {
                let shortcode = this.$route.params.shortcode;
                let { data: document_requests } = await axios.get(`/api/v1/client/docs/${shortcode}`);

                if (document_requests) {
                    // add file property for input to v-model onto
                    for(let document_request of document_requests){
                        document_request.file = null;
                    }

                    // move recieved documents to bottom of the list
                    document_requests.sort((a,b) => a.recieved - b.recieved);

                    this.document_requests = document_requests;
                }

            } catch (error) {
                console.error('document requests list request failed');
                console.error(error);
            }
            this.loading_document_requests = false;
        },

        onFileChange(event, index) {
            this.file[index] = event.target.files[0];
            this.single[index] = this.file[index].name;
        },

        async onDeleteFile(document_request) {

          if (confirm('Please to confirm to remove the file "' + document_request.filename + '"?')) {
            console.log('delete');
            this.delete_document_id = document_request.id;
            console.log(this.delete_document_id);
            try {
              await axios.post('/api/v1/client/deletedocs', {'document_request_id': this.delete_document_id});
            } catch (error) {
              console.error(error);
            }
            await this.loadDocumentRequests();
            this.delete_document_id = null;

          }
        },
        async openBSLink(document_request, btn = false) {
            if (btn) {
                window.open(document_request.url);
            }
            try {
                await axios.post(`/api/v1/client/docs/create_log/${document_request.id}`);
            } catch (error) {
                console.error('failed to log for link click');
                console.error(error);
            }
        },
        // Todo: Iframe don't work with illion unless window.PostMessage is implemented.
        // async clickBSLink(document_request) {
        //     this.show_upload_popup = true;
        //     this.iframe_url = document_request.url;
        //   try {
        //     await axios.post(`/api/v1/client/docs/create_log/${document_request.id}`);
        //   } catch (error) {
        //     console.error('failed to log for link click');
        //     console.error(error);
        //   }
        // },
        onCancel(){
            this.show_upload_popup = false;
        },
       async uploadAllFiles(){
            for (let i=0; i< this.all_selected_documents.length; i++) {
                await this.uploadFile(this.all_selected_documents[i]);
            }
            await this.loadDocumentRequests();
            this.showDialogPopup(
            "Upload files",
            'All files have been uploaded successfully!'
            );
        },
        setFiles(document_request , $event) {
            document_request.file = $event.target.files[0];
            this.all_selected_documents.push({file: $event.target.files[0], id: document_request.id});
        },

        async onAcceptingConset(document_request){
            this.accepting_consent_loader = true;
            try {
                await axios.post(`/api/v1/client/docs/${document_request.id}/accept-consent`);
                this.accepting_consent_loader = false;
            } catch (error) {
                this.showDialogPopup("Failure", error.response.data);
                this.accepting_consent_loader = false;
            }
            await this.loadDocumentRequests();

        }
    },
    created(){
        this.loadDocumentRequests();
    },
}
</script>

<style scoped>
    .md-ripple span.md-list-item-text {
        overflow: inherit;
        position: relative;
        width: auto;
    }
    div.file-name-text {
        line-height: 50px;
        text-align: right;
    }
</style>
